import type { IconType } from "react-icons";
import { FaCheckCircle, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";
import type { ToastType } from "./types";

export const TOAST_BACKGROUNDS: Record<ToastType, string> = {
  success: "bg-ticketon-green",
  error: "bg-ticketon-field-error-border",
  warning: "bg-amber-500",
};

export const TOAST_ICONS: Record<ToastType, IconType> = {
  success: FaCheckCircle,
  error: FaTimesCircle,
  warning: FaExclamationTriangle,
};

export const TOAST_ANIMATION_DURATION_MS = 300;
